module.exports = __webpack_public_path__ + "img/ffmpeg.7c2ab932.svg";